import styled from 'styled-components'

const CenteredContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default CenteredContent
